import { User as ApiUser } from '@infuse/api/e-connector/user';
import { User } from './model';

export const mapToDomain = (apiUser: ApiUser): User => {
  return { ...apiUser };
};
